import Link from "next/link";
import router from "next/router";
import React, { useState } from "react";
import useAuth from "../../contexts/AuthContext";
import Button from "../ui-kit/buttons/Button";
import NotificationCircle from "../ui-kit/buttons/NotificationCircle";
import DarkModeSwitch from "../ui-kit/form/switch/DarkModeSwitch";
import GitHubSvg from "../ui-kit/icons/GitHubSvg";
import Avatar from "../ui-kit/user/Avatar";
import UserLoggedIn from "../ui-kit/user/UserLoggedIn";

interface Props { }
const LoginArea: React.FC<Props> = (props) => {
  const { isAuthenticated, loggedInUser, loginTest } = useAuth();

  const login = async (e) => {
    e.preventDefault();
    if (process.env.NEXT_PUBLIC_ENV === "development") {
      loginTest();
    } else {
      router.push(`${process.env.NEXT_PUBLIC_API_URL}connect/github`);
    }
  };

  if (isAuthenticated)
    return (
      <section className="flex flex-row items-center justify-center space-x-4">
        {/* <NotificationCircle count={3} /> */}
        <div>
          <DarkModeSwitch />
        </div>
        <div className="">
          <Link href="/perfil">
            <a onClick={e => {
              e.stopPropagation();
            }}>
              <Avatar user={loggedInUser} width={40} height={40} />
            </a>
          </Link>
        </div>
      </section>
    );
  return (
    <section className="flex flex-row items-center justify-center space-x-4">
      <div>
        <DarkModeSwitch />
      </div>
      <div>
        <Button
          type="primary"
          Icon={
            <GitHubSvg className="w-6 h-6` text-white fill-current dark:text-black" />
          }
          onClick={login}
          size="sm"
          className="bg-black-bg dark:bg-white dark:text-black"
        >
          Iniciar Sesión
        </Button>
      </div>
    </section>
  );
};

export default LoginArea;
